export const PRODUCTION_DEPLOYMENT_EDITION = 'production';
export const STANDALONE_DEPLOYMENT_EDITION = 'standalone';

const PRODUCTION_ALIASES = new Set([
  PRODUCTION_DEPLOYMENT_EDITION,
  'hosted',
]);

const STANDALONE_ALIASES = new Set([
  STANDALONE_DEPLOYMENT_EDITION,
  'community',
  'docker',
  'staging',
]);

export function normalizeDeploymentEdition(value) {
  const normalizedValue = typeof value === 'string' ? value.trim().toLowerCase() : '';
  if (PRODUCTION_ALIASES.has(normalizedValue)) {
    return PRODUCTION_DEPLOYMENT_EDITION;
  }
  if (STANDALONE_ALIASES.has(normalizedValue)) {
    return STANDALONE_DEPLOYMENT_EDITION;
  }
  return null;
}

export function resolveDeploymentEdition({ deploymentEdition, currentEnvironment } = {}) {
  return normalizeDeploymentEdition(deploymentEdition)
    || normalizeDeploymentEdition(currentEnvironment)
    || PRODUCTION_DEPLOYMENT_EDITION;
}

export function getDeploymentEdition(environment = process.env) {
  return resolveDeploymentEdition({
    deploymentEdition: environment.REACT_APP_SAMSAR_DEPLOYMENT_EDITION,
    currentEnvironment: environment.REACT_APP_CURRENT_ENV,
  });
}

export function isGoogleLoginEnabled(environment = process.env) {
  return getDeploymentEdition(environment) === PRODUCTION_DEPLOYMENT_EDITION;
}
